import { CanActivateFn, RedirectCommand, Router } from '@angular/router';
import { inject } from '@angular/core';
import { LocalStorageDataAccess } from '@softline/core';
import { SOFTLINE_CONST_WWS_POS_DISPLAY_CONFIG_KEY } from '../pos-display.shared';

export const configuredGuard: CanActivateFn = () => {
  const router = inject(Router);
  const storage = inject(LocalStorageDataAccess);

  const config = storage.get({ key: SOFTLINE_CONST_WWS_POS_DISPLAY_CONFIG_KEY });

  if (!config) {
    const configPath = router.parseUrl('/pos-display/config');
    return new RedirectCommand(configPath);
  }

  return true;
};
